
import { defineComponent } from 'vue';

export default defineComponent({
    /*ログインレイアウト */
    name: 'LoginLayout',
    props: {
        isWide: {
            type: Boolean,
            default: false,
        },
        isWide770: {
            type: Boolean,
            default: false,
        },
        isWide900: {
            type: Boolean,
            default: false,
        },
        isWide1200: {
            type: Boolean,
            default: false,
        },
        isPadding: {
            type: Boolean,
            default: false,
        },
        isDisplay: {
            type: Boolean,
            default: true,
        },
        isChangeSpPadding: {
            type: Boolean,
            default: false,
        },
    },
});
